export const COURSE_SETUP_STEPS = [
  { id: "file", title: "Course file" },
  { id: "about", title: "About the course" },
  { id: "audience", title: "Who it's for" },
  { id: "picture", title: "Course picture" },
  { id: "modules", title: "Modules" },
  { id: "review", title: "Check and publish" },
] as const;

export type CourseSetupStepId = (typeof COURSE_SETUP_STEPS)[number]["id"];

export const COURSE_SETUP_STEP_COUNT = COURSE_SETUP_STEPS.length;

/** The step a draft opens on when the URL has a course but no step. */
export const DEFAULT_COURSE_SETUP_STEP: CourseSetupStepId = "about";

export const isCourseSetupStepId = (value: unknown): value is CourseSetupStepId =>
  typeof value === "string" && COURSE_SETUP_STEPS.some((step) => step.id === value);

export const getCourseSetupStepIndex = (stepId: CourseSetupStepId): number =>
  COURSE_SETUP_STEPS.findIndex((step) => step.id === stepId);

export const getCourseSetupStepTitle = (stepId: CourseSetupStepId): string =>
  COURSE_SETUP_STEPS[getCourseSetupStepIndex(stepId)].title;

export const getNextCourseSetupStep = (stepId: CourseSetupStepId): CourseSetupStepId | null =>
  COURSE_SETUP_STEPS[getCourseSetupStepIndex(stepId) + 1]?.id ?? null;

export const getPreviousCourseSetupStep = (stepId: CourseSetupStepId): CourseSetupStepId | null => {
  const index = getCourseSetupStepIndex(stepId);
  return index > 0 ? COURSE_SETUP_STEPS[index - 1].id : null;
};
